// src/store/slices/productsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constants/apiUrl";

export const toggleinstock = createAsyncThunk(
  "products/toggleinstock",
  async (productID, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state
console.log(state.auth.userArray.access_token,"state.auth.userArray.access_token");



      const response = await axios.post(
        `${apiUrl}/admin/products/${productID}/toggle-in-stock`,{},
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);


export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (filters, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state


      console.log(state.auth.userArray.access_token, "state.auth.userArray.access_token");

      const response = await axios.get(
        `${apiUrl}/admin/products`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addProduct = createAsyncThunk(
  "trainers/addProduct",
  async (productData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/products`, productData, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const updateProduct = createAsyncThunk(
  "products/updateProduct",
async ({ id, data }, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/products/${id}`, data, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: {
    list: [],
status: "idle",
    error: null,
    inStock:true
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })
      
      // toggleinstock
  .addCase(toggleinstock.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(toggleinstock.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(toggleinstock.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })











      .addCase(addProduct.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(addProduct.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(updateProduct.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(updateProduct.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })

  },
});

export default productsSlice.reducer;
